import EtablissementIdentAssociation from '@/generated/controls/etablissement/EtablissementIdentAssociation.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  extends: EtablissementIdentAssociation
})
